import React from "react";
import {MapContainer, Marker, useMapEvents} from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import BaseMapLayer from "./BaseMapLayer";
import L from 'leaflet';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

const MapEvents = ({ onClick }) => {
    useMapEvents({
        click: (e) => {
            if (onClick) {
                onClick(e);
            }
        },
    });

    return null;
};

// Crear iconos personalizados
const createCustomIcon = (color, iconSize, iconAnchor) => {
    return L.divIcon({
        className: "custom-icon",
        html: `
     <svg width="${iconSize[0]}" height="${iconSize[1]}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 0C33.8 0 20.3 13.5 20.3 30.1c0 6.4 2 12.3 5.4 17.1L50 100l24.3-52.7c3.4-4.8 5.4-10.7 5.4-17.1C79.7 13.5 66.2 0 50 0z" 
        fill="${color}"  stroke-width="4"/>
        <circle cx="50" cy="30" r="15" fill="white" />
      </svg>
    `,
        iconSize: iconSize,
        iconAnchor: iconAnchor,
        popupAnchor: [0, -35]
    });
};

// Iconos para origen, destino y escalas
const originIcon = createCustomIcon('#00b300', [38, 50], [19, 50]); // Verde
const destinationIcon = createCustomIcon('#ff0000', [38, 50], [19, 50]); // Rojo
const stopIcon = createCustomIcon('#0066ff', [30, 40], [15, 40]); // Azul (más pequeño)


// Componentes de marcador personalizado
export const OriginMarker = ({ position, draggable, eventHandlers, markerRef }) => (
    <Marker
        position={position}
        draggable={draggable}
        eventHandlers={eventHandlers}
        ref={markerRef}
        icon={originIcon}
    />
);

export const DestinationMarker = ({ position, draggable, eventHandlers, markerRef }) => (
    <Marker
        position={position}
        draggable={draggable}
        eventHandlers={eventHandlers}
        ref={markerRef}
        icon={destinationIcon}
    />
);

export const StopMarker = ({ position, draggable, eventHandlers, markerRef, children }) => {
    return (
        <Marker
            position={position}
            draggable={draggable}
            eventHandlers={eventHandlers}
            ref={markerRef}
            icon={stopIcon}
        >
            {children}
        </Marker>
    );
};


const Map = ({ children, center, zoom, scrollWheelZoom, style, onClick, whenCreated }) => {
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
    });

    return (
        <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom={scrollWheelZoom}
        style={style}
        whenCreated={whenCreated}
        >
            <BaseMapLayer />
            {onClick && <MapEvents onClick={onClick} />}
            {children}
        </MapContainer>
    )
}
export default Map
